import React, { useContext, useEffect, useState } from "react";
import styles from "./Banner.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../App";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import settingsService from "../../../services/settings";
import { useSelector } from "react-redux";

const OcBanner = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const width = useDeviceWidth();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";
  const [settings, setSettings] = useState({});
  const { homeApis } = useSelector((state) => state.widget); // Access widget data

  // const getSettings = async () => {
  //   const data = await settingsService.getAll();

  //   if (data?.data) {
  //     setSettings(data.data[0]);
  //   }
  // };

  // useEffect(() => {
  //   getSettings();
  // }, []);

  return (
    <div className={styles.banner}>
      <div className={styles.leftSection}>
        <img
          src={
            width > 1200
              ? data?.listingItems[0]?.webImage
              : data?.listingItems[0]?.mobileImage
          }
          alt="Banner"
          className={styles.mainImage}
        />
        <img
          src="/img/patterns/online-banner.svg"
          alt="Decorative pattern"
          className={styles.pattern}
        />
        <div className={styles.content}>
          <div style={{ position: "relative" }}>
            <div className={styles.overLay}></div>
            <h1
              data-aos="fade-right"
              data-aos-delay="100"
              className={`${styles.title} primary-500`}
            >
              {data?.listingItems[0]?.title}
            </h1>
            <p
              data-aos="fade-right"
              data-aos-delay="100"
              className={styles.description}
            >
              {data?.listingItems[0]?.description}
            </p>
            <a
              href={`https://wa.me/${homeApis?.adminSettings?.[0]?.whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <button
                data-aos="fade-right"
                data-aos-delay="100"
                onClick={() => {
                  const yPos = window.scrollY;
                  sessionStorage.setItem("scrollTargetY", yPos.toString());
                  setIsBackNavigation(true);
                  sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
                  // navigate("/consultation");
                }}
                className={`${styles.button} primary-hover border-primary-500`}
              >
                Connect via Message
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OcBanner;
